<template>
  <v-card
    id="con_lf_top_div"
    style="position:relative;overflow-wrap: anywhere;"
  >
    <v-tabs
      v-model="tab"
      background-color="primary accent-4"
      center-active
      dark
    >
      <v-tab
        v-if="role==='root' || role==='dispatcher'"
        href="#tab-1"
      >
        客户分配表
      </v-tab>

      <v-tab
        v-if="role==='root' || role==='dispatcher'"
        href="#tab-2"
      >
        大搜数据
      </v-tab>

      <v-tab
        v-if="role==='root' || role==='dispatcher' || role==='sem'"
        href="#tab-3"
      >
        多维度统计表
      </v-tab>

      <v-icon
        title="全屏显示"
        style="position:absolute;-moz-transform: rotate(-45deg);-webkit-transform: rotate(-45deg);right: 10px;top: 6px;font-size: 35px;"
        @click="screen"
      >
        mdi-arrow-all
      </v-icon>
    </v-tabs>
    <v-container
      fluid
      style="position:absolute;left:0px;top:48px;width:100%; z-index:5;padding:0px"
    >
      <v-data-iterator
        :items="items"
        hide-default-footer
      >
        <template v-slot:header>
          <v-toolbar
            dark
            color="cyan darken-1"
            size="20"
            height="50px"
          >
            <v-select
              v-model="year_s"
              clearable
              solo-inverted
              hide-details
              :items="year"
              :menu-props="{ top: true, offsetY: true }"
              prepend-inner-icon="mdi-calendar"
              item-text="label"
              item-value="value"
              label="年份"
              style="margin-left:10px;width:10%;"
              dense
              @change="selectsw"
            />
            <v-select
              v-model="month_s"
              clearable
              solo-inverted
              hide-details
              :items="month"
              :menu-props="{ top: true, offsetY: true }"
              prepend-inner-icon="mdi-calendar"
              item-text="label"
              item-value="value"
              label="月份"
              style="margin-left:10px;width:10%;"
              dense
              @change="selectsw"
            />
            <!--<v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              style="z-index:60;"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dates"
                  clearable
                  solo-inverted
                  hide-details
                  label="时间范围"
                  dense
                  style="margin-left:10px;width:210px;"
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  @change="selectsw"
                  @blur="selectsw"
                />
              </template>
              <v-date-picker
                v-model="dates"
                range
                no-title
                locale="zh-cn"
              />
            </v-menu>-->
            <template
              v-if="$vuetify.breakpoint.mdAndUp && tab==='tab-1'"
            >
              <v-select
                v-if="userInfo.roles==='root'"
                v-model="uid"
                clearable
                solo-inverted
                hide-details
                :items="keys"
                :menu-props="{ top: true, offsetY: true }"
                prepend-inner-icon="mdi-account"
                item-text="name"
                item-value="id"
                label="商务"
                style="margin-left:10px;width:10%;"
                dense
                @change="selectsw"
              />
              <v-select
                v-model="status"
                clearable
                solo-inverted
                hide-details
                :items="items"
                :menu-props="{ top: true, offsetY: true }"
                prepend-inner-icon="mdi-autorenew"
                item-text="label"
                item-value="value"
                label="状态"
                style="margin-left:10px;width:10%;"
                dense
                @change="selectsw"
              />
              <v-spacer />
            </template>
            <v-select
              v-if="tab==='tab-2'"
              v-model="qudao_s"
              clearable
              solo-inverted
              hide-details
              :items="qudao"
              :menu-props="{ top: true, offsetY: true }"
              prepend-inner-icon="mdi-calendar"
              item-text="label"
              item-value="value"
              label="渠道来源"
              style="margin-left:10px;width:10%;"
              dense
              @change="selectsw"
            />
          </v-toolbar>
        </template>
      </v-data-iterator>
    </v-container>

    <v-tabs-items
      v-model="tab"
      style="width:100%;"
    >
      <!--tab1-content-->
      <v-tab-item
        key="1"
        value="tab-1"
        style="width:100%;background:#f7f7f7;height:750px;overflow-x: auto;overflow-y: auto;"
      >
        <div
          style="margin-top:60px;"
        >
          <div class="oaTable_x1">
            <center
              colspan="13"
              style="font-size: 20px;font-weight:bold;line-height: 50px;color: #60b2d0;"
            >
              {{ year_s }}年{{ month_s }}月份客户推广分配表
            </center>
            <table
              width="2100px"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <tr>
                <td
                  width="150px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;height:40px!important"
                >
                  日期
                </td>
                <td
                  width="40px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  序号
                </td>
                <td
                  width="90px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  客户来源
                </td>
                <td
                  width="90px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  线索来源
                </td>
                <td
                  width="250px"
                  style="background:#1061A6;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  公司名称
                </td>
                <td
                  width="450x"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  概况描述
                </td>
                <td
                  width="100px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  分配AE
                </td>
                <td
                  width="150px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  搜索词
                </td>
                <td
                  width="150px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  关键词
                </td>
                <td
                  width="150px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  地域
                </td>
                <td
                  width="150px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  结果
                </td>
                <td
                  width="500px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #000!important;border-bottom:1px solid #000!important;"
                >
                  无效原因
                </td>
              </tr>
              <!--
          { text: '日期', value: 'extension_date', width: '110' },
          { text: '序号', value: 'no', sortable: false, width: '80' },
          { text: '客户来源', value: 'customer_source_name', width: '120' },
          { text: '线索来源', value: 'source_name', width: '120' },
          // { text: '客户姓名', value: 'name', sortable: false, width: '100' },
          { text: '公司名称', value: 'company', sortable: false, width: '250' },
          { text: '概况描述', value: 'description', sortable: false, width: '350' },
          { text: '分配AE', value: 'auther', width: '110' },
          { text: '搜索词', value: 'search_keyword', width: '120' },
          { text: '关键词', value: 'keyword', width: '120' },
          { text: '地域', value: 'region', width: '100' },
          { text: '结果', value: 'status', width: '100' },
          { text: '无效原因', value: 'invalid_name', width: '200' },
                -->

              <tbody
                v-for="(items1, index) in desserts"
                :key="index"
              >
                <tr>
                  <td
                    colspan="12"
                    style="background:#D5D6D5"
                  />
                </tr>
                <tr
                  v-for="(item, i) in items1.children"
                  :key="i"
                >
                  <td
                    v-if="i===0"
                    :rowspan="items1.children.length"
                    style="color:red!important;font-weight:bold!important;"
                  >
                    {{ items1.date }} {{ items1.week }}
                  </td>
                  <td>{{ item.no }}</td>
                  <td>{{ item.customer_source_name }}</td>
                  <td>{{ item.source_name }}</td>
                  <td
                    :title="item.company"
                  >
                    {{ item.company!==null ? item.company.substring(0,16) : '' }}
                  </td>
                  <td
                    :title="item.description"
                  >
                    {{ item.description!==null ? item.description.substring(0,30) : '' }}
                  </td>
                  <td>{{ item.auther }}</td>
                  <td>{{ item.search_keyword }}</td>
                  <td>{{ item.keyword }}</td>
                  <td>{{ item.region }}</td>
                  <td>{{ item.status }}</td>
                  <td>{{ item.invalid_name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br>
          <br>
          <!--<v-data-table
            dense
            :headers="headers"
            :items="desserts"
            sort-by="calories"
            class="elevation-1"
            style="color:black;overflow-x:auto;overflow-y:auto;height:600px;"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            calculate-widths
            @page-count="pageCount = $event"
          >
            <template v-slot:item.status="{ item }">
              <v-chip
                :color="getColor(item.status)"
                dark
              >
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="initialize"
              >
                Reset
              </v-btn>
            </template>
          </v-data-table>-->
        </div>
      </v-tab-item>
      <!--tab2-content-->
      <v-tab-item
        key="2"
        value="tab-2"
        style="width:100%;background:#f7f7f7;height:750px;overflow-x: auto;overflow-y: auto;"
      >
        <div
          style="margin-top:60px;"
        >
          <div class="oaTable_x2">
            <center
              colspan="13"
              style="font-size: 20px;font-weight:bold;line-height: 50px;color: #60b2d0;"
            >
              {{ year_s }}年{{ month_s }}月份大搜数据
            </center>
            <table
              width="2100px"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <tr>
                <td
                  width="160px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;height:40px!important"
                >
                  日期
                </td>
                <td
                  width="220px"
                  colspan="2"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  推广时间
                </td>
                <td
                  width="100px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  展现
                </td>
                <td
                  width="80px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  点击
                </td>
                <td
                  width="150px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  平均点击价格
                </td>
                <td
                  width="90x"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  点击率
                </td>
                <td
                  width="90px"
                  style="background:#7F7F7F;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  消费
                </td>
                <td
                  width="150px"
                  style="background:#C00000;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  总咨询量
                </td>
                <td
                  width="150px"
                  style="background:#489BC9;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  电话客户咨询
                </td>
                <td
                  width="150px"
                  style="background:#489BC9;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  商桥客户咨询
                </td>
                <td
                  width="150px"
                  style="background:#489BC9;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  网站留电
                </td>
                <td
                  width="90px"
                  style="background:#489BC9;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  线索
                </td>
                <td
                  width="90px"
                  style="background:#489BC9;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  无效
                </td>
                <td
                  width="90px"
                  style="background:#489BC9;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  待定
                </td>
                <td
                  width="100px"
                  style="background:#489BC9;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  高价值
                </td>
                <td
                  width="120px"
                  style="background:#489BC9;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  有效约见
                </td>
                <td
                  width="120px"
                  style="background:#489BC9;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  X资源总和
                </td>
                <td
                  width="150px"
                  style="background:#D17E14;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  咨询成本
                </td>
                <td
                  width="150px"
                  style="background:#D17E14;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  线索成本
                </td>
                <td
                  width="150px"
                  style="background:#D17E14;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  有效约见成本
                </td>
                <td
                  width="150px"
                  style="background:#D17E14;color:#ffffff !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  X资源成本
                </td>
              </tr>
              <!--<tbody
                v-for="(items1, index) in desserts"
                :key="index"
              >
                <tr>
                  <td
                    colspan="12"
                    style="background:#D5D6D5"
                  />
                </tr>
                <tr
                  v-for="(item, i) in items1.children"
                  :key="i"
                >
                  <td
                    v-if="i===0"
                    :rowspan="items1.children.length"
                    style="color:red!important;font-weight:bold!important;"
                  >
                    {{ items1.date }} {{ items1.week }}
                  </td>
                  <td>{{ item.no }}</td>
                  <td>{{ item.customer_source_name }}</td>
                  <td>{{ item.source_name }}</td>
                  <td
                    :title="item.company"
                  >
                    {{ item.company!==null ? item.company.substring(0,16) : '' }}
                  </td>
                  <td
                    :title="item.description"
                  >
                    {{ item.description!==null ? item.description.substring(0,30) : '' }}
                  </td>
                  <td>{{ item.auther }}</td>
                  <td>{{ item.search_keyword }}</td>
                  <td>{{ item.keyword }}</td>
                  <td>{{ item.region }}</td>
                  <td>{{ item.status }}</td>
                  <td>{{ item.invalid_name }}</td>
                </tr>
              </tbody>-->
              <tbody
                v-for="(item, index) in desserts_2"
                :key="index"
              >
                <tr>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;background:#70AD47;color:#ffffff!important"
                    rowspan="2"
                  >
                    {{ item.extension_date }} {{ item.week }}
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    上午
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    9:00-12:00
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    &nbsp;
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    &nbsp;
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    &nbsp;
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    &nbsp;
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    &nbsp;
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    &nbsp;
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    {{ item.dh_am }}
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    {{ item.sq_am }}
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    {{ item.wz_am }}
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    {{ item.xs_am }}
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    {{ item.wx_am }}
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    {{ item.dd_am }}
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    {{ item.gjz_am }}
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    {{ item.yx_am }}
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    {{ item.xzy_am }}
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    &nbsp;
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    &nbsp;
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    &nbsp;
                  </td>
                  <td
                    style="font-size: 14px!important;font-weight: 300!important;"
                  >
                    &nbsp;
                  </td>
                </tr>
                <tr>
                  <td>下午</td>
                  <td>14:00-18:00</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>{{ item.dh_pm }}</td>
                  <td>{{ item.sq_pm }}</td>
                  <td>{{ item.wz_pm }}</td>
                  <td>{{ item.xs_pm }}</td>
                  <td>{{ item.wx_pm }}</td>
                  <td>{{ item.dd_pm }}</td>
                  <td>{{ item.gjz_pm }}</td>
                  <td>{{ item.yx_pm }}</td>
                  <td>{{ item.xzy_pm }}</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td
                    style="background:#70AD47;color:#ffffff!important"
                    height="16"
                  >
                    合计
                  </td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>{{ item.views }}</td>
                  <td>{{ item.click }}</td>
                  <td>¥{{ item.average }}</td>
                  <td>{{ item.click_rate }}%</td>
                  <td>{{ item.quota }}</td>
                  <td>{{ item.consulting_total }}</td>
                  <td>{{ item.dh_hj }}</td>
                  <td>{{ item.sq_hj }}</td>
                  <td>{{ item.wz_hj }}</td>
                  <td>{{ item.xs_hj }}</td>
                  <td>{{ item.wx_hj }}</td>
                  <td>{{ item.dd_hj }}</td>
                  <td>{{ item.gjz_hj }}</td>
                  <td>{{ item.yx_hj }}</td>
                  <td>{{ item.xzy_hj }}</td>
                  <td>¥{{ item.zzxcb }}</td>
                  <td>¥{{ item.xs_cb }}</td>
                  <td>¥{{ item.xy_cb }}</td>
                  <td>¥{{ item.xzy_cb }}</td>
                </tr>
                <tr
                  class="oaTable_line"
                >
                  <td
                    colspan="22"
                    style="background:#D5D6D5;"
                  />
                </tr>
              </tbody>
              <tr>
                <td
                  style="background:#70AD47;color:#ffffff!important"
                  height="16"
                  colspan="3"
                >
                  {{ month_s }}月推广数据总结
                </td>
                <td>{{ ext_2.views_total }}</td>
                <td>{{ ext_2.click_total }}</td>
                <td>¥{{ ext_2.average_total }}</td>
                <td>{{ ext_2.click_rate_total }}%</td>
                <td>¥{{ ext_2.quota_total }}</td>
                <td>{{ ext_2.zx_total }}</td>
                <td>{{ ext_2.dh_total }}</td>
                <td>{{ ext_2.sq_total }}</td>
                <td>{{ ext_2.wz_total }}</td>
                <td>{{ ext_2.xs_total }}</td>
                <td>{{ ext_2.wx_total }}</td>
                <td>{{ ext_2.dd_total }}</td>
                <td>{{ ext_2.gjz_total }}</td>
                <td>{{ ext_2.yx_total }}</td>
                <td>{{ ext_2.xzy_total }}</td>
                <td>¥{{ ext_2.zzxcb_total }}</td>
                <td>¥{{ ext_2.xs_cb_total }}</td>
                <td>¥{{ ext_2.xy_cb_total }}</td>
                <td>¥{{ ext_2.xzy_cb_total }}</td>
              </tr>
              <tr
                class="oaTable_line"
              >
                <td
                  colspan="22"
                  style="background:#D5D6D5;"
                />
              </tr>
            </table>
            <table
              width="600px"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <tr>
                <td
                  width="150px"
                  style="color:#000 !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;height:40px!important"
                >
                  {{ month_s }}月份咨询总量
                </td>
                <td
                  width="150px"
                  style="color:#000 !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  {{ month_s }}月份线索总量
                </td>
                <td
                  width="150px"
                  style="color:#000 !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  咨询未获线索
                </td>
                <td
                  width="150px"
                  style="color:#000 !important;border-top:1px solid #999!important;border-bottom:1px solid #999!important;"
                >
                  所占比例
                </td>
              </tr>
              <tr>
                <td>{{ ext_2.zx_total }}</td>
                <td>{{ ext_2.xs_total }}</td>
                <td>{{ ext_2.zx_total - ext_2.xs_total }}</td>
                <td>{{ ((ext_2.zx_total - ext_2.xs_total)/ext_2.zx_total).toFixed(2) }}</td>
              </tr>
            </table>
          </div>
          <br>
          <br>

          <!--<v-data-table
            :headers="headers_2"
            :items="desserts_2"
            sort-by="calories"
            class="elevation-1"
            style="color:black;overflow-x: auto;overflow-y: auto;height: 650px;"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            :search="qudao_s"
            @page-count="pageCount = $event"
          >
            <template v-slot:item.extension_time="{ item }">
              {{ item.extension_am }}<br>
              {{ item.extension_pm }}
            </template>
            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="initialize"
              >
                Reset
              </v-btn>
            </template>
          </v-data-table>-->
        </div>
      </v-tab-item>
      <!--tab3-start-->
      <v-tab-item
        key="3"
        value="tab-3"
        style="width:100%;height:750px;background:#f7f7f7;overflow-x: auto;overflow-y: auto;"
      >
        <div
          style="margin-top:60px;"
        >
          <div class="oaTable_x1">
            <center
              colspan="13"
              style="font-size: 20px;font-weight:bold;line-height: 50px;color: #60b2d0;"
            >
              {{ year_s }}年{{ month_s }}月多维度数据表
            </center>
            <table
              width="2000px"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <tr>
                <td
                  width="120px"
                  style="background:#C4D79B;"
                >
                  日期
                </td>
                <td
                  width="120px"
                  style="background:#C4D79B;"
                >
                  访问时间
                </td>
                <td
                  width="120px"
                  style="background:#C4D79B;"
                >
                  搜索来源
                </td>
                <td
                  width="300px"
                  style="background:#C4D79B;"
                >
                  初始页面
                </td>
                <td
                  width="120px"
                  style="background:#C4D79B;"
                >
                  IP
                </td>
                <td
                  width="90px"
                  style="background:#C4D79B;"
                >
                  平台
                </td>
                <td
                  width="200px"
                  style="background:#C4D79B;"
                >
                  搜索词
                </td>
                <td
                  width="200px"
                  style="background:#C4D79B;"
                >
                  关键词
                </td>
                <td
                  width="90px"
                  style="background:#C4D79B !important"
                >
                  来源
                </td>
                <td
                  width="120px"
                  style="background: #c4d79b;"
                >
                  有无线索
                </td>
                <!--<td
                  width="120px"
                  style="background:#C4D79B;"
                >
                  是否真实客户
                </td>-->
                <td
                  width="120px"
                  style="background:#C4D79B;"
                >
                  是否有效
                </td>
                <td
                  width="500px"
                  style="background:#C4D79B;"
                >
                  无效原因
                </td>
              </tr>
              <tr
                v-for="(item, i) in desserts_3"
                :key="i"
              >
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.extension_date }}
                </td>
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.extension_time }}
                </td>
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.source_name }}
                </td>
                <td
                  :style="item.color===1 ? 'background:#FDE9D9;' : 'background:#DAEEF3'"
                  :title="item.page"
                >
                  {{ item.page!==null ? item.page.substring(0,35) : '' }}
                </td>
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.ip }}
                </td>
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.terminal_name }}
                </td>
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.search_keyword }}
                </td>
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.keyword }}
                </td>
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.customer_source_name }}
                </td>
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.is_clue === 1 ? '有' : '无' }}
                </td>
                <!--<td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.customer_source_name }}
                </td>-->
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.status }}
                </td>
                <td
                  :style="item.color===1 ? 'background:#FDE9D9' : 'background:#DAEEF3'"
                >
                  {{ item.invalid_name }}
                </td>
              </tr>
            </table>
          </div>
          <br>
          <br>
          <!--<v-data-table
            :headers="headers_3"
            :items="desserts_3"
            sort-by="calories"
            class="elevation-1"
            style="color:black;overflow-x: auto;overflow-y: auto;height: 650px;"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.is_clue="{ item }">
              {{ item.is_clue === 1 ? '有' : '无' }}
            </template>
            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="initialize"
              >
                Reset
              </v-btn>
            </template>
          </v-data-table>-->
        </div>
      </v-tab-item>
      <!--tab3-end-->
    </v-tabs-items>
  </v-card>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'ReportView',
    data () {
      return {
        fullscreen: false,
        status: '',
        uid: '',
        role: '',
        tab: null,
        valid: true,
        userInfo: [],
        year: [],
        year_s: new Date().getFullYear(),
        month_s: '',
        month: [
          { value: '01', label: '一月' },
          { value: '02', label: '二月' },
          { value: '03', label: '三月' },
          { value: '04', label: '四月' },
          { value: '05', label: '五月' },
          { value: '06', label: '六月' },
          { value: '07', label: '七月' },
          { value: '08', label: '八月' },
          { value: '09', label: '九月' },
          { value: '10', label: '十月' },
          { value: '11', label: '十一月' },
          { value: '12', label: '十二月' },
        ],
        qudao_s: '19',
        qudao: [
          { value: '19', label: '百度推广' },
          { value: '20', label: '阿拉丁' },
          { value: '21', label: '知识营销' },
          { value: '22', label: '其他' },
        ],
        items: [
          {
            value: 29,
            label: '客户池',
          },
          {
            value: 30,
            label: '待定',
          },
          {
            value: 51,
            label: '高价值待定',
          },
          {
            value: 31,
            label: '有效约见',
          },
          {
            value: 32,
            label: '报价后高意愿',
          },
          {
            value: 33,
            label: '报价后低意愿',
          },
          {
            value: 36,
            label: '签约',
          },
          {
            value: 34,
            label: '谎称要签',
          },
          {
            value: 35,
            label: '输单',
          },
          {
            value: 37,
            label: '无效',
          },
        ],
        keyword: '',
        keys: [],
        dates: [],
        menu1: false,
        headers: [
          { text: '日期', value: 'extension_date', width: '110' },
          { text: '序号', value: 'no', sortable: false, width: '80' },
          { text: '客户来源', value: 'customer_source_name', width: '120' },
          { text: '线索来源', value: 'source_name', width: '120' },
          // { text: '客户姓名', value: 'name', sortable: false, width: '100' },
          { text: '公司名称', value: 'company', sortable: false, width: '250' },
          { text: '概况描述', value: 'description', sortable: false, width: '350' },
          { text: '分配AE', value: 'auther', width: '110' },
          { text: '搜索词', value: 'search_keyword', width: '120' },
          { text: '关键词', value: 'keyword', width: '120' },
          { text: '地域', value: 'region', width: '100' },
          { text: '结果', value: 'status', width: '100' },
          { text: '无效原因', value: 'invalid_name', width: '200' },
        ],
        desserts: [],
        headers_2: [
          { text: '日期', value: 'extension_date', width: '150' },
          { text: '推广时间', value: 'extension_time', sortable: false, width: '120' },
          { text: '渠道来源', value: 'source_name', width: '120' },
          { text: '展现', value: 'views', width: '120' },
          { text: '点击', value: 'click', width: '120' },
          { text: '平均点击价格', value: 'average', sortable: false, width: '120' },
          { text: '点击率', value: 'click_rate', sortable: false, width: '120' },
          { text: '消费', value: 'quota', sortable: false, width: '120' },
          { text: '电话咨询', value: 'no', width: '120' },
          { text: '商桥咨询', value: 'no', width: '120' },
          { text: '网站留电', value: 'no', width: '120' },
          { text: '总咨询', value: 'consulting', width: '120' },
          { text: '线索', value: 'no', width: '120' },
          { text: '无效', value: 'no', width: '120' },
          { text: '待定', value: 'no', width: '120' },
          { text: '有效约见', value: 'no', width: '120' },
          { text: '意向总和', value: 'no', width: '120' },
          { text: '咨询成本', value: 'no', width: '120' },
          { text: '线索成本', value: 'no', width: '120' },
          { text: '意向客户成本', value: 'no', width: '120' },
          { text: '有效约见成本', value: 'no', width: '120' },
        ],
        desserts_2: [],
        ext_2: [],
        headers_3: [
          { text: '日期', value: 'extension_date', width: '110' },
          { text: '访问时间', value: 'extension_time', sortable: false, width: '110' },
          { text: '搜索来源', value: 'source_name', width: '120' },
          { text: '初始页面', value: 'page', width: '300' },
          { text: 'IP', value: 'ip', width: '150' },
          { text: '平台', value: 'terminal_name', sortable: false, width: '100' },
          { text: '搜索词', value: 'search_keyword', sortable: false, width: '120' },
          { text: '关键词', value: 'keyword', sortable: false, width: '120' },
          { text: '来源', value: 'customer_source_name', width: '120' },
          { text: '有无线索', value: 'is_clue', width: '120' },
          // { text: '是否真实客户', value: 'keyword', width: '120' },
          { text: '是否有效', value: 'status', width: '120' },
          { text: '无效原因', value: 'invalid_name', width: '200' },
        ],
        desserts_3: [],
        page: 1,
        pageCount: 0,
        itemsPerPage: 5000,
        classifyArr: [],
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // 获取销售列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/customer/admins')
          .then(response => {
            if (response.status === 200) {
              this.keys = response.data.data.data
              this.role = response.data.role
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取lib
        axios
          .get(process.env.VUE_APP_BASE_API + '/classify/all')
          .then(response => {
            if (response.data.code === 20000) {
              this.classifyArr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取用户列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/admins/profile')
          .then(response => {
            if (response.data.code === 20000) {
              this.userInfo = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取年份
        axios
          .get(process.env.VUE_APP_BASE_API + '/report/year')
          .then(response => {
            if (response.data.code === 20000) {
              this.year = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取工作
        this.mywork()
      },
      mywork () {
        // 客户数据
        axios
          .post(process.env.VUE_APP_BASE_API + '/report/customer', { userId: this.uid, dates: this.dates, status: this.status, year: this.year_s, month: this.month_s })
          .then(response => {
            if (response.data.code === 20000) {
              this.desserts = response.data.data
              this.year_s = response.data.ext[0]
              this.month_s = response.data.ext[1]
              this.desserts.map((items, index, arr) => {
                items.children.map((item, i, arr) => {
                  switch (item.status) {
                    case 29:
                      item.status = '客户池'
                      break
                    case 30:
                      item.status = '待定'
                      break
                    case 51:
                      item.status = '高价值待定'
                      break
                    case 31:
                      item.status = '有效约见'
                      break
                    case 32:
                      item.status = '报价后高意愿'
                      break
                    case 33:
                      item.status = '报价后低意愿'
                      break
                    case 36:
                      item.status = '签约'
                      break
                    case 34:
                      item.status = '谎称要签'
                      break
                    case 35:
                      item.status = '输单'
                      break
                    case 37:
                      item.status = '无效'
                      break
                  }
                  item.no = i + 1
                  item.customer_source_name = this.classifyArr[item.customer_source]
                  item.source_name = this.classifyArr[item.source]
                  const invalid = item.invalid_tip !== null ? '(' + item.invalid_tip + ')' : ''
                  const sole = item.sole_tip !== null ? '(' + item.sole_tip + ')' : ''
                  const iname = this.classifyArr[item.invalid_status] + invalid
                  item.invalid_name = iname !== 'undefined' ? iname : ''
                  const isole = this.classifyArr[item.sole_status] + sole
                  item.sole_name = isole !== 'undefined' ? isole : ''
                })
              })
              // console.log(this.classifyArr)
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 大搜数据
        axios
          .post(process.env.VUE_APP_BASE_API + '/report/marketing', { dates: this.dates, year: this.year_s, month: this.month_s, qudao: this.qudao_s })
          .then(response => {
            if (response.data.code === 20000) {
              this.desserts_2 = response.data.data
              this.ext_2 = response.data.total
              this.desserts_2.map((item, i, arr) => {
                item.no = i + 1
                item.source_name = this.classifyArr[item.source]
                // item.extension_date = item.extension_date + '(' + this.getWeek(item.extension_date) + ')'
              })
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 多维度数据
        axios
          .post(process.env.VUE_APP_BASE_API + '/report/dimension', { dates: this.dates, year: this.year_s, month: this.month_s })
          .then(response => {
            if (response.data.code === 20000) {
              this.desserts_3 = response.data.data
              this.desserts_3.map((item, i, arr) => {
                item.no = i + 1
                switch (item.status) {
                  case 29:
                    item.status = '待定'
                    break
                  case 30:
                    item.status = '待定'
                    break
                  case 51:
                    item.status = '高价值待定'
                    break
                  case 31:
                    item.status = '有效约见'
                    break
                  case 32:
                    item.status = '有效约见'
                    break
                  case 33:
                    item.status = '有效约见'
                    break
                  case 36:
                    item.status = '有效约见'
                    break
                  case 34:
                    item.status = '有效约见'
                    break
                  case 35:
                    item.status = '有效约见'
                    break
                  case 37:
                    item.status = '无效'
                    break
                }
                item.customer_source_name = this.classifyArr[item.customer_source]
                item.source_name = this.classifyArr[item.source]
                item.terminal_name = this.classifyArr[item.terminal]
                const invalid = item.invalid_tip !== null ? '(' + item.invalid_tip + ')' : ''
                const iname = this.classifyArr[item.invalid_status] + invalid
                item.invalid_name = iname !== 'undefined' ? iname : ''
              })
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      selectsw () {
        this.mywork()
      },
      getColor (calories) {
        let color = 'green'
        switch (calories) {
          case '客户池':
            color = 'info'
            break
          case '待定':
            color = '#FD9A13'
            break
          case '高价值待定':
            color = 'rgb(16 175 74 / 63%)'
            break
          case '有效约见':
            color = 'teal'
            break
          case '报价后高意愿':
            color = 'blue'
            break
          case '报价后低意愿':
            color = 'lime'
            break
          case '签约':
            color = 'green'
            break
          case '谎称要签':
            color = 'brown'
            break
          case '输单':
            color = 'blue-grey'
            break
          case '无效':
            color = 'grey'
            break
        }
        return color
      },

      screen () {
        // let element = document.documentElement;//设置后就是我们平时的整个页面全屏效果
        const element = document.getElementById('con_lf_top_div') // 设置后就是   id==con_lf_top_div 的容器全屏
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen()
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen()
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen()
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen()
          }
        }
        this.fullscreen = !this.fullscreen
      },

      /**
       * 根据日期字符串获取星期几
       * @param dateString 日期字符串（如：2020-05-02）
       * @returns {String}
       */
      getWeek (dateString) {
        const dateArray = dateString.split('-')
        const date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2])
        return '周' + '日一二三四五六'.charAt(date.getDay())
      },
    },
  }
</script>

<style type="text/css">
  .oaTable_x1 *{padding:0!important; margin:0!important;}
  .oaTable_x1 table{border-collapse:collapse!important;table-layout:fixed}
  .oaTable_x1 table td{
    border:1px solid #000!important;
    border-left: none!important;
    height:30px!important;
    font-size:14px!important;
    color:#000!important;
    text-align:center!important;
  }
  .oaTable_x1 table tr:nth-child(1) td{ font-size:15px!important; font-weight:bold!important; color:#000!important; border:none!important;border-right:1px solid #000!important;  letter-spacing:1px!important}
  .oaTable_x2 *{padding:0!important; margin:0!important;}
  .oaTable_x2 table{border-collapse:collapse!important;table-layout:fixed}
  .oaTable_x2 table td{
    border:1px solid #999!important;
    border-left: none!important;
    height:40px!important;
    font-size:14px!important;
    color:#000!important;
    text-align:center!important;
  }
  .oaTable_x2 table tr:nth-child(1) td{ font-size:15px!important; font-weight:bold!important; color:#000!important; border:none!important;border-right:1px solid #999!important;  letter-spacing:1px!important}

</style>
